export interface SustainabilityStat {
  id: string;
  label: string;
  value: string;
  explanation: string;
}

export interface SustainabilityMetrics {
  asOf: string; // ISO date, last refresh
  carbonSaved: SustainabilityStat;
  lowCarbonOrders: SustainabilityStat;
  ecoPackagingAdoption: SustainabilityStat;
}

// TODO(backend): populate from an anonymised, aggregated BigQuery pull once
// that pipeline exists. Deliberately null, not a plausible-looking placeholder
// number — same reasoning as trustScore.ts/caseStudies.ts: these are framed
// by their own ticket (ZP-43/ZP-47) as audited business metrics sourced from
// real order volume, not composite-persona narrative copy. A fabricated
// carbon-saved or eco-packaging-adoption figure would be exactly the kind of
// specific, checkable claim this project's honesty policy rules out.
// CarbonImpactDashboard.tsx / EcoPackagingImpact.tsx render a "coming soon"
// state while this is null.
export const SUSTAINABILITY_METRICS: SustainabilityMetrics | null = null;

// Descriptive/definitional copy, not a numeric claim about actual order
// volume — nothing here is independently checkable against an external
// record, so it ships as real content (same register as certifications.ts's
// body text).
export const ECO_PACKAGING_MATERIALS_COPY =
  "When active, our eco-packaging option replaces polystyrene coolers with recyclable, curbside-compostable insulated liners and paper-based ice packs — same cold-chain performance, less landfill weight.";

export const LOW_CARBON_ORDER_DEFINITION_COPY =
  "An order qualifies as low-carbon when it's grouped into an existing delivery route in your area rather than dispatched as a one-off trip, and when it's sourced from the harbour closest to your delivery hub rather than the widest available radius.";
